import type { OptionType } from "./SingleSelect";

type MetaOptionLabelContext = { context: "menu" | "value" };

/**
 * Option renderer for dropdowns whose options carry extra meta (e.g. batch): the label with the
 * meta underneath in the menu, and compact `label (meta)` once selected.
 */
export const formatOptionWithMeta = (option: OptionType, { context }: MetaOptionLabelContext) => {
    const meta = option.meta ?? [];
    if (meta.length === 0) return option.label;
    if (context === "value") {
        return `${option.label} (${meta.map((m) => m.value).join(", ")})`;
    }
    return (
        <div>
            <div>{option.label}</div>
            <small className="text-muted">{meta.map((m) => `${m.key}: ${m.value}`).join(" · ")}</small>
        </div>
    );
};
